export default __webpack_public_path__ + "static/media/24-hours-select.b5d1daae.svg";